import ChartSupport from "./ChartSupport";

class ChartConfig {

	references = new Map();

	currentURL = null;

	urlParams = null;

	// Selectors for Key Figure Comparison

	KFC_CHART_HOLDER_SELECTOR = '.nhs-kfc-chart';
	KFC_SELECT_TOGGLE_SELECTOR = '.nhs-kfc-chart-select__toggle';
	KFC_SWITCH_SELECTOR = 'input[name="chartdata"]';
	KFC_SWITCH_CATEGORY_SELECTOR = 'input[name="chartcategory"]';
	KFC_CURRENT_SERIES_SELECTOR = 'input[name=chartdata]:checked';
	KFC_EXPORT_SELECTOR = '.js-export-chart';
	KFC_CHART_YAXIS = '';
	KFC_CHART_YAXIS_OPPOSITE = '';
	KFC_CHART_IS_INDEXED = false;
	KFC_CHART_VISIBLE_SERIES = [];



	getChart( chartId ) {
		let config = this.references.get( chartId );
		if ( typeof config !== 'undefined' ) {
			if ( config.has( 'chart' ) && config.get( 'chart' ) !== null ) {
				return config.get( 'chart' );
			} else {
				console.log( "Chart '" + chartId + "' not initialized." );
			}
		} else {
			console.log( "Chart '" + chartId + "' not found." );
		}
		return null;
	}


	setChart( chartId, reference ) {
		let config = this.references.get( chartId );
		if ( typeof config === 'undefined' ) {
			this.references.set( chartId, new Map( [['chart', reference]] ) );
		} else {
			config.set( 'chart', reference );
		}
	}


	getChartSelector( chartId, selectorId ) {
		let config = this.references.get( chartId );
		if ( typeof config !== 'undefined' ) {
			if ( config.has( selectorId ) ) {
				return config.get( selectorId );
			} else {
				console.log( "Chart selector '" + selectorId + "' not found." );
			}
		} else {
			console.log( "Chart '" + chartId + "' not found." );
		}
		return null;
	}


	setChartSelector( chartId, selectorId ) {
		let config = this.references.get( chartId );
		if ( typeof config === 'undefined' ) {
			this.references.set( chartId, new Map( [['chart', null]] ) );
			config = this.references.get( chartId );
		}
		let elements = [...document.querySelectorAll(selectorId)];
		config.set( selectorId, elements );
		return elements;
	}


}

export default new ChartConfig();
